const SDK_VERSION = '7.108.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
